import React, { useState } from "react"
import styled from "styled-components"
import fonts from "../../styles/fonts"
import colors from "../../styles/colors"
import breakpoints from "../../styles/breakpoints"
import { getLocalisedPrice } from "../../services/productHelper"
import { Link } from "gatsby"
import {
  addAction,
  removeAction,
  updateItemAction,
} from "../../store/actions/cart/index"
import { getRemoved, getRemoving, isLoading } from "../../store/reducers"
import { connect } from "react-redux"
import {
  BASE_PATH_ENGAGEMENT,
  getEngagementLink,
  getProductLinkByMaterial,
} from "../../services/links"
import { withTranslation } from "gatsby-plugin-react-i18next"
import { getLocaleOptionValues, getLocaleShape } from "../../services/locale"
import Add from "../../resources/img/ui/quantity/add-green-small.svg"
import Subtract from "../../resources/img/ui/quantity/subtract-green-small.svg"
import { Col, Row } from "styled-bootstrap-grid"
import { GatsbyImage } from "gatsby-plugin-image"
import DiscountSticker from "../Core/DiscountSticker"
import { cvgTrack } from "../../services/converge"
import { getCart } from "../../services/cartHelper"

const StyledContainer = styled.div`
  padding: 18px 30px;
  border-bottom: 1px solid ${colors.newBorderGrey};
  display: flex;
  flex-wrap: nowrap;
  opacity: ${(props) => (props.$removing ? "0.5" : "1")};

  @media (min-width: ${breakpoints.sm}) {
    padding: 18px 25px 18px 34px;
  }
`

const ProductImageContainer = styled.div`
  min-width: 129px;
  max-width: 129px;
  min-height: 129px;
  max-height: 129px;
  background: ${colors.white};
  border: 1px solid #979797;
`

const ProductImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  min-width: 100%;
  max-width: 100%;
  min-height: 100%;
  max-height: 100%;

  img {
    object-fit: contain !important;
  }
`

const Details = styled.div`
  padding: 13px 0 13px 18px;
  display: flex;
  width: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  position: relative;
`
const FirstRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 4px;
`

const Info = styled.div`
  width: 100%;
`
const BoldDetail = styled.h3`
  ${fonts.helveticaNeueMedium};
  font-size: ${(props) => (props.$price ? "14px" : "12px")};
  line-height: normal;
  color: ${colors.black};
`

const Detail = styled.div`
  ${fonts.helveticaNeueLight};
  color: ${colors.textGrey};
  font-size: 10px;
  line-height: 16px;
`

const DetailValue = styled.div`
  text-transform: ${(props) => (props.$engraving ? "auto" : "capitalize")};
  display: inline-block;

  span {
    text-transform: none;
  }
`

const QuantityRow = styled.div`
  ${fonts.helveticaNeueLight};
  color: ${colors.textGrey};
  font-size: 10px;
  line-height: 16px;
  display: flex;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

const ButtonText = styled.div`
  ${fonts.helveticaNeueLight};
  color: ${colors.textGrey};
  font-size: 10px;
  line-height: 16px;
  text-decoration: underline;
`

const StyledButton = styled.button`
  outline: none;
  padding: 0;
  background: transparent;
  border: none;
  display: flex;
  cursor: pointer;
  margin: 0;
`

const StyledLink = styled(Link)`
  height: 100%;
  display: flex;
`

const Buttons = styled.div`
  ${fonts.helveticaNeueLight};
  color: ${colors.textGrey};
  font-size: 10px;
  line-height: 16px;
  width: 100%;
  display: flex;
  margin-top: 2px;
  span {
    margin: 0 2px;
  }
`

const Quantity = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    line-height: 16px;
    margin: 0 2px;
  }
`

const QuantityButton = styled.button`
  outline: none;
  background: transparent;
  padding: 0;
  width: 16px;
  height: 20px;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
`

const OriginalPrice = styled.div`
  ${fonts.helveticaNeue};
  color: #979797;
  font-size: 10px;
  letter-spacing: 0.68px;
  line-height: 16px;
  text-transform: uppercase;
  font-style: italic;
  margin-top: -3px;
  margin-right: 0;
  text-align: center;
  display: flex;
  justify-content: flex-end;
  div {
    position: relative;
    display: flex;
  }
`

const Line = styled.span`
  position: absolute;
  width: 120%;
  border-top: 1px solid #979797;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const DiscountCol = styled(Col)`
  position: relative;
`

const trackUpdateCart = (lineItemIds, allProducts, value) => {
  const cart = JSON.parse(getCart())
  // find the items in the cart that match the lineItemIds
  ;(cart["items"] || []).forEach((item) => {
    if (lineItemIds.includes(item["lineItemId"])) {
      const product = allProducts.find((p) => p.handle === item.handle)
      cvgTrack({
        event: value < 0 ? "Removed From Cart" : "Added To Cart",
        properties: {
          variant_id: item.variantId.split("/").pop(),
          product_id: product.shopifyId.split("/").pop(),
          sku: item.handle,
          name: item.title,
          variant_name: item.title,
          price: parseFloat(item.price),
          currency: item.currencyCode,
          vendor: "kimai",
          quantity: value >= 0 ? value : -value,
        },
      })
    }
  })
}

const BagItemDetails = (props) => {
  const {
    handle,
    image,
    title,
    price,
    currencyCode,
    customAttributes,
    lineItemIds,
    options,
    quantity,
    engagement,
    shape,
    removeAction,
    t,
    discountAmount,
    gift,
    totalQuantity,
    createdAt,
    allProducts,
    content,
  } = props

  const [gettingRemoved, setGettingRemvoed] = useState(false)

  const removeFromCart = () => {
    setGettingRemvoed(true)
    const removeItem = new Promise((resolve) => {
      resolve(removeAction(lineItemIds))
    })
    removeItem.then(() => setGettingRemvoed(false))
  }

  const updateQuantity = (e, value) => {
    e.preventDefault()

    let updatedQuantity = quantity + value

    const { isLoading } = props

    if (isLoading) {
      return
    }

    trackUpdateCart(lineItemIds, allProducts, value)

    if (updatedQuantity > 0) {
      updateCartItem(updatedQuantity, lineItemIds)
    } else {
      removeFromCart()
    }
  }

  const updateCartItem = (quantity, lineItemIds) => {
    const { updateItemAction } = props

    updateItemAction(lineItemIds, quantity)
  }

  let totalPrice = price * quantity
  let discountedPrice = totalPrice
  let discountPercentage

  if (discountAmount > 0) {
    discountedPrice = totalPrice - discountAmount
    discountPercentage = Math.ceil((discountAmount * 100) / totalPrice)
  }

  const colourOption = options?.find(
    (option) =>
      option.name.trim() === "Colour" || option.name.trim() === "Color"
  )

  const link = engagement
    ? getEngagementLink(content.slug)
    : handle === "oprah-eternity-band"
      ? `${BASE_PATH_ENGAGEMENT}oprah-eternity-ring`
      : handle === "oprah-0-2ct-eternity-ring"
        ? `${BASE_PATH_ENGAGEMENT}oprah-0-2ct-eternity-ring`
        : handle === "the-coco-ring"
          ? `${BASE_PATH_ENGAGEMENT}the-coco-ring`
          : handle === "jane-plain-band"
            ? `${BASE_PATH_ENGAGEMENT}jane`
            : handle === "cecilia-ring-band"
              ? `${BASE_PATH_ENGAGEMENT}cecilia-oval`
              : handle === "simone-plain-band"
                ? `${BASE_PATH_ENGAGEMENT}simone`
                : getProductLinkByMaterial(
                    handle,
                    colourOption?.value,
                    createdAt,
                    colourOption ? false : true
                  )

  return (
    <StyledContainer $removing={gettingRemoved ? 1 : 0}>
      {image && (
        <ProductImageContainer>
          <Link to={link}>
            <ProductImage image={image.gatsbyImageData} alt={title || ""} />
          </Link>
        </ProductImageContainer>
      )}
      <Details>
        <Info>
          <FirstRow>
            <BoldDetail>{title}</BoldDetail>
            <BoldDetail $discount={discountAmount > 0 ? 1 : 0} $price={1}>
              {getLocalisedPrice(discountedPrice, currencyCode)}
            </BoldDetail>
          </FirstRow>
          <Row>
            <Col
              xs={discountAmount > 0 ? 9 : 12}
              sm={discountAmount > 0 ? 9 : 12}
            >
              {engagement && shape && (
                <Detail>
                  <DetailValue>
                    {getLocaleShape(shape)}
                    <span>{t("minicart.engagement.shape")}</span>
                  </DetailValue>
                </Detail>
              )}
              {options?.map((option, index) => (
                <Detail key={index}>
                  <DetailValue>
                    {getLocaleOptionValues(option.value)}
                  </DetailValue>
                </Detail>
              ))}
              {customAttributes &&
                !engagement &&
                customAttributes.map((customAttribute, index) => {
                  return (
                    <Detail key={index}>
                      <DetailValue $engraving={1}>
                        {customAttribute.value}
                      </DetailValue>
                    </Detail>
                  )
                })}
              {customAttributes &&
                engagement &&
                customAttributes.map((customAttribute, index) => {
                  return (
                    customAttribute.key === t("pdp.engraving") && (
                      <Detail key={index}>
                        <DetailValue $engraving={1}>
                          {customAttribute.value}
                        </DetailValue>
                      </Detail>
                    )
                  )
                })}
              <QuantityRow>
                <Detail></Detail>
                {!engagement && (
                  <Quantity>
                    {!gift || (gift && totalQuantity === 1) ? (
                      <>
                        <QuantityButton onClick={(e) => updateQuantity(e, -1)}>
                          <img src={Subtract} alt="Remove quanitty" />
                        </QuantityButton>
                        <span>{quantity}</span>
                        <QuantityButton onClick={(e) => updateQuantity(e, 1)}>
                          <img src={Add} alt="Add quanitty" />
                        </QuantityButton>
                      </>
                    ) : (
                      <div>
                        <span>
                          {quantity} <br />
                          Free Gift
                        </span>
                      </div>
                    )}
                  </Quantity>
                )}
              </QuantityRow>
            </Col>
            {discountAmount > 0 && (
              <DiscountCol xs={3} sm={3}>
                <OriginalPrice>
                  <div>
                    {getLocalisedPrice(totalPrice, currencyCode)}
                    <Line />
                  </div>
                </OriginalPrice>
                {discountAmount > 0 && (
                  <DiscountSticker cart={1}>
                    {discountPercentage}
                  </DiscountSticker>
                )}
              </DiscountCol>
            )}
          </Row>
        </Info>
        {(!gift || (gift && totalQuantity === 1)) && (
          <Buttons>
            <StyledButton onClick={() => removeFromCart()}>
              <ButtonText>{t("minicart.remove")}</ButtonText>
            </StyledButton>
          </Buttons>
        )}
      </Details>
    </StyledContainer>
  )
}

const mapStateToProps = (state) => {
  return {
    removing: getRemoving(state),
    removed: getRemoved(state),
    isLoading: isLoading(state),
  }
}

const mapDispatchToProps = {
  removeAction,
  updateItemAction,
  addAction,
}

const TranslatedBagItems = withTranslation()(BagItemDetails)

export default connect(mapStateToProps, mapDispatchToProps)(TranslatedBagItems)
